import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_org/org/portal/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/org/portal/dashboard' });
  },
});
